import { useState, useEffect } from "react"
import { Grid, Typography, List, ListItem, ListItemText, ListItemIcon, Button, Box, Container } from "@mui/material"
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord'
import NomineeModal from "./NomineeModal";
import { useAppData } from "../../redux/appDataProvider";
import ApiClient from "../../utilities/apiClient";
import { useSelector } from "react-redux";
import AppConfig from "../../AppConfig";
import MyLodder from "../../components/lodder";

const AddNominee = () => {

    const { userInfo } = useAppData()

    const [modal, setModal] = useState(false)
    const [userStaus, setUserStatus] = useState({})
    const [loading, setLoading] = useState(true)

    const apiToken = useSelector(state => state.auth.apiToken);

    useEffect(() => {
        if (userInfo && !modal) {
            (async () => {
                try {
                    const apiClient = new ApiClient(apiToken);

                    const response = await apiClient.fetchData(
                        `${AppConfig.api.Request.nomineeQuery}/${userInfo.CLIENT_ID}`,
                        "GET"
                    );

                    if (!response) {
                        console.error("Error: Response is missing.");
                    } else if (response.status === 200) {
                        setUserStatus(response.data.Nomination);
                    } else if (response.status === 500) {
                        const errorMessage = response.statusText || (response.details && response.details["Error Description"]);
                        console.error("Error 500: ", errorMessage);
                    } else {
                        console.warn("Unexpected response status:", response.status);
                    }
                } catch (error) {
                    console.error("Error fetching nominee details", error);
                } finally {
                    setLoading(false);
                }

            })()
        }
    }, [userInfo, modal])

    const handleAddNominee = () => {
        setModal(true)
    }

    const handleClose = () => {
        setModal(false)
    }

    if (loading) {
        return (
            <Grid container justifyContent="center" alignItems="center" sx={{ minHeight: '70vh' }}>
                <MyLodder canShow={loading} />
            </Grid>
        )
    }

    return (
        <Container sx={{ background: "#241E41", minHeight: "100vh" }}>

            <Box sx={{ px: { xs: 2, sm: 3, md: 5 }, py: { xs: 3, sm: 4 } }}>

                {userStaus?.verification_status === "pending" && userStaus?.esign_status !== "pending" ? (

                    <Grid container spacing={2} justifyContent="center" mt={6}>
                        <Grid item xs={12} md={10} lg={8}>
                            <Typography sx={{ fontSize: { xs: '16px', sm: '22px' }, fontWeight: 500 }}>
                                We have initiated the registration of nominations with Stock Exchanges and Demat Account with the Depository. This usually takes 24 to 48 hours in registering your nominations.
                            </Typography>
                        </Grid>

                        <Grid item xs={12}>
                            <Grid container justifyContent="center">
                                <Grid item>
                                    <Typography
                                        sx={{
                                            color: "#f3d45e",
                                            fontSize: { xs: "16px", sm: "22px" },
                                            textAlign: "center",
                                        }}
                                    >
                                        Status : Pending
                                    </Typography>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                ) : userStaus?.verification_status === "approved" ? (

                    <Grid container spacing={2} justifyContent="center" mt={6}>
                        <Grid item xs={12} md={10} lg={8}>
                                <Typography sx={{ fontSize: { xs: '18px', sm: '22px' }, fontWeight: 500, textAlign: "center" }}>
                                You have been added nominations successfully.

                            </Typography>
                        </Grid>

                        <Grid item xs={12}>
                            <Grid container justifyContent="center">
                                <Grid item>
                                    <Typography
                                        sx={{
                                            color: "#f3d45e",
                                            fontSize: { xs: "16px", sm: "22px" },
                                            textAlign: "center",
                                        }}
                                    >
                                        Status : Approved
                                    </Typography>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                ) :
                    (<Grid container spacing={2} >
                        <Grid item xs={12}>
                            <Typography sx={{ fontSize: { xs: '18px', sm: '20px' }, fontWeight: 600, letterSpacing: 0.5 }}>Nomination Details</Typography>
                        </Grid>

                        <Grid item xs={12}>
                            <Typography sx={{ fontSize: { xs: '16px', sm: '20px' } }}>No Nominees Added Yet{" "}
                                <Typography component="span" sx={{ color: "#999", fontSize: { xs: "14px", sm: "16px" } }}>(Add Nominees for your Trading & Demat account)</Typography>
                            </Typography>
                        </Grid>

                        <Grid item xs={12}>
                            <Typography sx={{ color: "#F3D45E", fontSize: { xs: '16px', sm: '20px' }, fontWeight: 600, letterSpacing: 0.5 }}>Before you proceed</Typography>
                        </Grid>
                        <Grid item xs={12}>
                            <List dense disablePadding sx={{ pl: { xs: 2, sm: 3 } }}>
                                {[
                                    "Online nomination is allowed only one time. You will not be able to modify the details later.",
                                    "Ensure that the details of your nominee are updated correctly. You will be able to review the same before eSign.",
                                    "Please note that this information is only for your stock trading account and not for mutual fund."
                                ].map((text, idx) => (
                                    <ListItem key={idx} disableGutters>
                                        <ListItemIcon sx={{ minWidth: '24px' }}>
                                            <FiberManualRecordIcon sx={{ fontSize: 10, color: "#F3D45E" }} />
                                        </ListItemIcon>
                                        <ListItemText primary={text} primaryTypographyProps={{ fontSize: { xs: "14px", sm: "16px" } }}  />
                                    </ListItem>
                                ))}
                            </List>
                        </Grid>

                        <Grid item xs={12} display="flex" justifyContent="end" pt={2}>
                            <Button
                                onClick={handleAddNominee}
                            >
                                Add Nomination
                            </Button>
                        </Grid>

                        <NomineeModal
                            open={modal}
                            setModal={setModal}
                            handleClose={handleClose}
                        />


                        {userStaus?.verification_status === "rejected" && (<>
                            <Grid item xs={12} display="flex" justifyContent="center">
                                <Typography sx={{ fontSize: { xs: '16px', sm: '22px' }, fontWeight: 500 }}>
                                    Your nomination request was rejected. You can submit a new nomination again.

                                </Typography>
                            </Grid>



                            <Grid item xs={12} display="flex" justifyContent="center">
                                <Typography sx={{ fontSize: { xs: "16px", sm: "22px" } }}>Cause: {userStaus?.verified_comments}</Typography>
                            </Grid>

                            <Grid item xs={12} display="flex" justifyContent="center">
                                <Typography sx={{ color: "#A52A2A", fontSize: { xs: "16px", sm: "22px" } }}>Status : Rejected</Typography>
                            </Grid>

                        </>)}


                    </Grid>)}
            </Box>
        </Container>

    )
}

export default AddNominee